import { UserProfile, ProfileFormData } from '../types/profile';
import { sanitizeEmail } from '../utils/validation';

const PROFILE_STORAGE_KEY = 'userProfile';
const PROFILE_EXPIRY_DAYS = 7;

/**
 * Save user profile to localStorage with expiry
 */
export const saveUserProfile = (formData: ProfileFormData): UserProfile => {
  const now = new Date();
  const expiryDate = new Date(now);
  expiryDate.setDate(expiryDate.getDate() + PROFILE_EXPIRY_DAYS);

  const profile: UserProfile = {
    email: sanitizeEmail(formData.email),
    createdAt: now.toISOString(),
    expiresAt: expiryDate.toISOString(),
  };

  localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(profile));

  return profile;
};

/**
 * Get user profile from localStorage
 * Returns null if not found or expired
 */
export const getUserProfile = (): UserProfile | null => {
  try {
    const stored = localStorage.getItem(PROFILE_STORAGE_KEY);
    if (!stored) {
      return null;
    }

    const profile: UserProfile = JSON.parse(stored);

    // Check if expired
    const now = new Date();
    const expiryDate = new Date(profile.expiresAt);

    if (now > expiryDate) {
      clearUserProfile();
      return null;
    }

    return profile;
  } catch (error) {
    console.error('Error reading user profile:', error);
    return null;
  }
};

/**
 * Clear user profile from localStorage
 */
export const clearUserProfile = (): void => {
  localStorage.removeItem(PROFILE_STORAGE_KEY);
};
